/**
 * Created by andreyna on 10/27/2016.
 */
import BaseService from "../../base/base_service";
import Model from "./game_conversion_model";
import {SYSTEM_EVENTS} from '../../events/events';
import Event from '../../utils/event';
import _ from '../../utils/underscore';
import DOM from '../../utils/dom';


const MILLI_SECONDS = 1000;

class GameConversionService extends BaseService {

    /**
     * @static
     * @type {string}
     */
    static CLASS = 'GameConversionService';


    /**
     * @property
     * @type {object|null}
     * @private
     */
    _model = null;
    _timeout = null;


    /**
     *
     * @param params
     */
    init(params) {
        super.init(params);
        this._model = Model.create(params);
        this._subscribe();
    }


    /**
     * Activate timer and reactivate it until all flags will be timed out
     *
     * @param eventName
     * @private
     */
    _activateTimer(eventName, flagTime) {
        this.logger.debug('Start conversion event timer => ', {eventName: eventName, flagIndex: this._model.getActiveFlag(), flagTime: flagTime});
        //fire event when the flag timer is expired
        this._timeout = DOM.setTimeout((event) => {
            this.logger.debug('Expired conversion event timer => ', {eventName: eventName, flagIndex: this._model.getActiveFlag(), flagTime: flagTime});
            Event.fire(event);
            let nextFlag = this._model.setActiveFlag(this._model.getActiveFlag() + 1);
            if (!_.isNumber(nextFlag)) {
                return;
            }
            this._activateTimer(event, nextFlag);
        }, flagTime * MILLI_SECONDS, eventName);
    }

    _isAuthorized() {
        return this.serviceFactory.oAuth2Service().isAuthorized();
    }

    /**
     * Subscribe to OPEN / CLOSE game events and on / off the timers
     * @private
     */
    _subscribe() {
        this.onSystemEvent(SYSTEM_EVENTS.GAME_OPEN, (gameData) => {
            if (gameData.isReal) {
                return;
            }
            this._model.resetFlag();

            let eventType = SYSTEM_EVENTS.CONVERSION_PRE_LOGIN_EVENT;
            if (this._isAuthorized()) {
                eventType = SYSTEM_EVENTS.CONVERSION_POST_LOGIN_EVENT;
            }
            //activate first timer
            let flagTime = this._model.setActiveFlag(0);
            this._activateTimer(eventType, flagTime);
        });

        this.onSystemEvent(SYSTEM_EVENTS.CLOSE_GAME, () => {
            this.logger.debug('CLOSE GAME');
            this._resetFlag();
        });


        this.onSystemEvent(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, () => {
            //Check whether the flag (timer) is running
            this.logger.debug('OAUTH_STATE_CHANGE');
            if (this._model.getActiveFlag() === -1) {
                return;
            }

            this._resetFlag();
            if (this._isAuthorized()) {
                this._activateTimer(SYSTEM_EVENTS.CONVERSION_POST_LOGIN_EVENT, this._model.setActiveFlag(0));
            }
        });
    }

    _resetFlag() {
        this.logger.debug('RESET FLAGS');
        if (this._timeout) {
            DOM.clearTimeout(this._timeout);
            this._timeout = null;
        }
        this._model.resetFlag();
    }

}

export default GameConversionService;